/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-07T11:35:36-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-20T10:46:08-07:00
*/


import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, color, textColor, borders } from '../../style';

const style = StyleSheet.create({
  buttonSetContainer: {
    display: 'inline-block',
    // padding: '4px',
    cursor: 'pointer',
    // height: '38px',
    // border: borders.DEFAULT,
    borderRadius: '4px'
  },
});

const RadioButtonSet = (props) => {
  const {
    children,
    ...rest
  } = props

  return (
    <div className={css(style.buttonSetContainer)}>
      {props.children}
    </div>
  )
};

RadioButtonSet.propTypes = {
  children: React.PropTypes.node.isRequired,
};

export default RadioButtonSet;



// WEBPACK FOOTER //
// ./src/components/common/RadioButtonSet.jsx